var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivE" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", fixed: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c("v-toolbar-title", [_vm._v("Contactos Notificados")]),
                  _c("v-spacer")
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c("br"),
              _c(
                "div",
                { staticClass: "cardnew", attrs: { align: "center" } },
                [
                  _c("br"),
                  _c(
                    "v-flex",
                    { attrs: { md10: "" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "rounded-card" },
                        [
                          _c(
                            "v-container",
                            {
                              attrs: {
                                "text-xs-center": "",
                                "grid-list-md": ""
                              }
                            },
                            [
                              _c(
                                "div",
                                { attrs: { align: "left" } },
                                [
                                  _c("v-flex", { attrs: { md12: "" } }, [
                                    _c(
                                      "h2",
                                      {
                                        staticClass: "h2_title",
                                        staticStyle: {
                                          "margin-top": "12px!important",
                                          "font-weight": "normal"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    Contactos Notificados\n                  "
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              ),
                              _c("v-divider"),
                              _c("br"),
                              _c(
                                "v-form",
                                {
                                  ref: "form",
                                  attrs: { "lazy-validation": "" },
                                  model: {
                                    value: _vm.validForm,
                                    callback: function($$v) {
                                      _vm.validForm = $$v
                                    },
                                    expression: "validForm"
                                  }
                                },
                                [
                                  _c(
                                    "v-card-text",
                                    [
                                      _c("v-flex", { attrs: { md12: "" } }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "gridcard rounded-card"
                                          },
                                          [
                                            _c("ag-grid-vue", {
                                              staticClass: "ag-theme-material",
                                              staticStyle: {
                                                width: "100%",
                                                height: "380px",
                                                "font-family":
                                                  "'Asap', sans-serif"
                                              },
                                              attrs: {
                                                columnDefs:
                                                  _vm.columnDefsNotificados,
                                                rowData: _vm.contactosRespaldo,
                                                pagination: "true",
                                                paginationPageSize: "5",
                                                suppressRowClickSelection:
                                                  "true",
                                                sideBar: _vm.sideBar,
                                                localeText: _vm.localeText,
                                                onGridReady: _vm.onGridReady,
                                                postProcessPopup:
                                                  _vm.onClickCell,
                                                suppressCopyRowsToClipboard:
                                                  "true",
                                                suppressCsvExport: true,
                                                suppressExcelExport: true
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }